

import Gallery from '../../../../modules/Gallery';


import foto_1 from './foto_1.jpg'
import foto_2 from './foto_2.jpg'
import foto_3 from './foto_3.jpg'
import foto_4 from './foto_4.jpg'


const slides = [
    {
      src: foto_1,
      title: 'Slide Title One',
      description: 'Slide Description One\n\nthis is new line',
    },
    {
      src: foto_2,
      title: 'Slide Title Two',
      description: 'Slide Description Two',
    },
    {
      src: foto_3,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    },
    {
      src: foto_4,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    }
]



export default function Index() {

    return (
        <div className='container'>

            <div className='mt-3'>
                <h3>Entrega de anchetas 2024</h3>
                <p>
                    En el marco de la implementación de la Dimensión Estratégica Social, 
                    COOPMULMAG reafirma su compromiso con el fortalecimiento de la comunicación 
                    institucional y el bienestar integral de sus asociados. En esta ocasión, 
                    conmemoramos la Navidad mediante la entrega de anchetas familiares, 
                    promoviendo los valores de equidad, solidaridad y unidad, y contribuyendo 
                    al fortalecimiento del núcleo familiar como base esencial de nuestra comunidad cooperativa.</p>
            </div>
            <Gallery slides={slides} ></Gallery>
        </div>
    )

}